<div class="container landing-container post-page-wrapper">
  <div class="page-head">
    <div class="head-aside">
      <div class="multi-select-block">
        <ng-multiselect-dropdown [placeholder]="'Choose topic'" [settings]="dropdownSettings" [data]="articleTopicList"
                                 [(ngModel)]="selectTags">
        </ng-multiselect-dropdown>
      </div>
      <app-dropdown [label]="'Language'" [data]="articleLanguageList" [valueField]="'value'" [textField]="'text'"
                    [selectValue]="selectLanguage" (valueChange)="languageChange($event)">
      </app-dropdown>
      <div class="connection-st-grp">
        <button *ngIf="selectLanguage == articleLangaugeType.English" class="btn st-public" title="English">
          English
        </button>
        <button *ngIf="selectLanguage == articleLangaugeType.Indonesian" class="btn st-public" title="Indonesian">
          Indonesian
        </button>
      </div>
      <app-dropdown [label]="'Set level'" [data]="articleLevelList" [valueField]="'value'" [textField]="'text'"
                    [optionStyle]="'style'" [selectValue]="selectLevel" [descrptionField]="'description'"
                    (valueChange)="optionChange($event)">
      </app-dropdown>
      <div class="connection-st-grp">
        <button *ngIf="selectLevel == articleAccessLevelType.Public" class="btn st-public" title="Public">
          <img src="../assets/images/ic-user-sm.svg" alt="Icon" />
          Public
        </button>
        <button *ngIf="selectLevel == articleAccessLevelType.Followers" class="btn st-followers" title="Follower">
          <img src="../assets/images/ic-user-sm.svg" alt="Icon" />
          Followers
        </button>
        <button *ngIf="selectLevel == articleAccessLevelType.Connections" class="btn st-connections"
                title="Connections">
          <img src="../assets/images/ic-user-sm.svg" alt="Icon" />
          Connections
        </button>
      </div>
    </div>
    <div class="head-end">
      <div class="btn-grps">
        <button class="btn btn-eye border-0" [class.st-active]="articleStatus!==articleStatusType.Published" disabled>
          <img src="../assets/images/ic-eye-open.svg" alt="Icon" class="default-icon" />
          <img src="../assets/images/ic-eye-close.svg" alt="Icon" class="active-icon" />
        </button>
        <button class="btn" title="Translation" (click)="openConfirmTransactionModal(confirmTranslationModal)">
          Translation
        </button>
        <button class="btn" title="Publish" (click)="publishArticle()">Publish</button>
        <button class="btn" (click)="saveAsDraft()">
          <img src="../assets/images/ic-save.svg" alt="Icon" />
        </button>
      </div>
    </div>
  </div>

  <div class="post-content-wrap">
    <section dndDropzone (dndDrop)="onDrop($event)" class="dropzon-outer article-area">
      <div class="post-comp-block  {{element.elementId === articleElementType.SubLine?'subline-block-spacing':
        element.elementId=== articleElementType.Header?'header-block-spacing':''}}" [dndDraggable]="element"
           [dndDisableDragIf]="element.isActiveForEdit ||  element.isInHighLightMode" [dndEffectAllowed]="'copyMove'"
           (dndStart)="onArticleBlockDragStart($event)"
           *ngFor="let element of articleBlockList; let i = index; trackBy: identify">
        <div class="drop-thumb-wrapper editable" [ngSwitch]="element.elementId">
          <div *ngIf="!(element.isActiveForEdit || element?.isInHighLightMode)" class="add-ui-block inside-block">
            <div ngbDropdown>
              <button class="btn btn-add-item" ngbDropdownToggle (shown)="onDropdownShown()" (click)="onDropdownShown()">
                <!-- <img src="./assets/images/ic-add-white.svg" alt="Icon" id="dropdownBasic1"  /> -->
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9" width="3" height="21" fill="currentColor" />
                  <rect y="12" width="3" height="21" transform="rotate(-90 0 12)" fill="currentColor" />
                </svg>

              </button>
              <div ngbDropdownMenu #dropdownMenu aria-labelledby="dropdownBasic1" class="post-element-dropdown">
                <div #scrollBarContainer class="dropdown-scroll-wrapper">
                  <button ngbDropdownItem [dndEffectAllowed]="'copy'" (dndDrag)="onStart($event)"
                          (click)="addElement(element,i)" [dndDraggable]="element" *ngFor="let element of articleElementList">
                    <img src="../assets/images/ic-drag-{{element.name.replaceAll(' ','').toLowerCase()}}.svg"
                         alt="Icon" [ngClass]="{'resto-details-icon': element.id === 11}" />
                    <span class="link-text">{{ element.name }} {{ element.id }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Article Header element edit/view box -->
          <app-article-header *ngSwitchCase="articleElementType.Header" [blockElement]="element"
                              (blockElementChange)="updateElement($event, i)"></app-article-header>

          <!-- Article Text element edit/view box -->
          <app-article-paragraph *ngSwitchCase="articleElementType.Text" [blockElement]="element"
                                 (blockElementChange)="updateElement($event, i)"></app-article-paragraph>

          <!-- Article List element edit/view box -->
          <app-article-list *ngSwitchCase="
                articleElementType.List" [blockElement]="element" (blockElementChange)="updateElement($event, i)"
                            (openHighLightButtonClick)="openHighLightModel($event)"></app-article-list>

          <!-- Article Main Image element edit/view box -->
          <article-upload-image *ngSwitchCase="articleElementType.MainImage" [blockElement]="element"
                                (blockElementChange)="updateElement($event,i)"
                                (onCancelBtn)="onImageCancel($event,i)"></article-upload-image>

          <!-- Article Subline element edit/view box -->
          <app-article-subline *ngSwitchCase="articleElementType.SubLine" [blockElement]="element"
                               (blockElementChange)="updateElement($event, i)"></app-article-subline>

          <!-- Article quote element edit/view box -->
          <app-article-quote *ngSwitchCase="articleElementType.Quote" [blockElement]="element"
                             (blockElementChange)="updateElement($event, i)"></app-article-quote>

          <!-- Article quote element edit/view box -->
          <app-article-lead *ngSwitchCase="articleElementType.Lead" [blockElement]="element"
                            (blockElementChange)="updateElement($event, i)"></app-article-lead>


          <!-- Article Video element edit/view box -->
          <app-article-video *ngSwitchCase="articleElementType.Video" [blockElement]="element"
                             (blockElementChange)="updateElement($event, i)"
                             (onUrlValueChange)="element.isValidData=$event"></app-article-video>


          <!-- Article Image element edit/view box -->
          <app-article-image *ngSwitchCase="articleElementType.Image" [blockElement]="element"
                             (blockElementChange)="updateElement($event, i)" [isFromEditor]="true"
                             [stopAnimation]="stopAnimation"></app-article-image>

          <!-- Article Link element edit/view box -->
          <app-article-link *ngSwitchCase="articleElementType.Link" [blockElement]="element"
                            (blockElementChange)="updateElement($event, i)"></app-article-link>

          <!-- Article Add Restaurant element edit/view box -->
          <app-article-add-resto-details *ngSwitchCase="articleElementType.AddRestoDetails" [blockElement]="element"
                                         (blockElementChange)="updateElement($event, i)" [restaurantType]="restaurantData"></app-article-add-resto-details>

          <!-- Article Element edit/delete buttons -->
          <div class="cta-block">
            <button *ngIf="element.elementId==articleElementType.List && !element.isActiveForEdit && !element.isInHighLightMode"
                    class="btn" (click)="addTextIndentation(element)">
              <svg *ngIf="element?.isTextWithIndentationInList" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <line x1="120" y1="128" x2="216" y2="128" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24" />
                <line x1="120" y1="64" x2="216" y2="64" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24" />
                <line x1="40" y1="192" x2="216" y2="192" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24" />
                <polyline points="40 56 80 96 40 136" fill="none" stroke="currentColor" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="24" />
              </svg>
              <svg *ngIf="!element?.isTextWithIndentationInList" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <line x1="120" y1="128" x2="216" y2="128" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24" />
                <line x1="120" y1="64" x2="216" y2="64" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24" />
                <line x1="40" y1="192" x2="216" y2="192" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24" />
                <polyline points="72 56 32 96 72 136" fill="none" stroke="currentColor" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="24" />
              </svg>
            </button>
            <button *ngIf="!element.isActiveForEdit && !element.isInHighLightMode && element.elementId==articleElementType.List"
                    class="btn" (click)="openForHighlight(element)" title="Highlight">
              <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">

              <!-- Uploaded to: SVG Repo, www.svgrepo.com, Transformed by: SVG Repo Mixer Tools -->
              <svg fill="currentColor" width="250px" height="250px" viewBox="0 0 1024.00 1024.00"
                   xmlns="http://www.w3.org/2000/svg" class="icon" stroke="currentColor" stroke-width="63.488">

                <g id="SVGRepo_bgCarrier" stroke-width="0" />

                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC"
                   stroke-width="8.192" />

                <g id="SVGRepo_iconCarrier">
                  <path d="M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z" />
                </g>
              </svg>
            </button>
            <button *ngIf="isSaveButtonShow(element)" class="btn" [disabled]="isSaveButtonDisable(element)"
                    (click)="saveBlock(element)" title="Save">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2583_337)">
                  <path d="M11.636 11.6367H4.36328V13.0912H11.636V11.6367Z" fill="currentColor" />
                  <path d="M4.36328 14.5459V15.2731V16.0004H11.636V15.2731V14.5459H4.36328Z" fill="currentColor" />
                  <path d="M15.8543 4.18259L12.932 0.290625C12.7946 0.107688 12.5792 0 12.3504 0H11.1515V0.727281V1.45456V6.06063C11.1515 6.46222 10.8259 6.78791 10.4242 6.78791H3.63637C3.23472 6.78791 2.90909 6.46222 2.90909 6.06063V1.45453V0.727281V0H0.727281C0.325625 0 0 0.325688 0 0.727281V15.2727C0 15.6743 0.325625 16 0.727281 16H2.90909V15.2727V14.5454V13.8182V10.9091C2.90909 10.5074 3.23472 10.1818 3.63637 10.1818H12.3637C12.7653 10.1818 13.0909 10.5073 13.0909 10.9091V13.8182V14.5454V15.2727V16H15.2727C15.6744 16 16 15.6743 16 15.2727V4.61928C16 4.46181 15.9488 4.3085 15.8543 4.18259Z"
                        fill="currentColor" />
                  <path d="M4.36328 0V0.727281V1.45453V5.33334H9.69663V1.45453V0.727281V0H4.36328Z"
                        fill="currentColor" />
                </g>
                <defs>
                  <clipPath id="clip0_2583_337">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button class="btn" *ngIf="isSaveButtonShow(element)"
                    (click)="openDiscardChangesModal(discardChangesModal,element.displayOrder)" title="discard changes">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"
                   style="width: 14px; height: 14px;">
                <path d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                      fill="currentColor" />
              </svg>

            </button>
            <button *ngIf="isEditButtonShow(element)" (click)="editBlock(element,i)" class="btn" title="Edit">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                      fill="currentColor" />
              </svg>
            </button>
            <button *ngIf="element.isActiveForEdit && element.elementId==articleElementType.Image && element.imageCount==4"
                    class="btn" title="Edit layout" (click)="openLayout(element)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0.9V17.1C0 17.3387 0.0948211 17.5676 0.263604 17.7364C0.432387 17.9052 0.661305 18 0.9 18H17.1C17.3387 18 17.5676 17.9052 17.7364 17.7364C17.9052 17.5676 18 17.3387 18 17.1V0.9C18 0.661305 17.9052 0.432387 17.7364 0.263604C17.5676 0.0948211 17.3387 0 17.1 0H0.9C0.661305 0 0.432387 0.0948211 0.263604 0.263604C0.0948211 0.432387 0 0.661305 0 0.9ZM9.9 1.8H16.2V8.1H9.9V1.8ZM9.9 9.9H16.2V16.2H9.9V9.9ZM1.8 1.8H8.1V16.2H1.8V1.8Z"
                      fill="currentColor" />
              </svg>
            </button>
            <button class="btn btn-delete" (click)="openDeleteSectionModal(deleteSectionModal,element.displayOrder)"
                    title="Delete">
              <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                      fill="currentColor" />
                <path fill-rule=" evenodd" clip-rule="evenodd"
                      d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                      fill="currentColor" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- </div> -->
      <!-- This div will showup when their is no content -->
      <!-- <div *ngIf="!articleBlockList?.length" class="temp-view-block">
          Drop your content here (Dropzone)
        </div> -->
      <!-- Placeholder content when hovering into dropzone -->
      <div dndPlaceholderRef class="placeholder-ref">Drop here</div>
    </section>

    <!-- Article element menu dropdown -->
    <div class="add-ui-block">
      <div ngbDropdown #myDropdown="ngbDropdown">
        <button class="btn btn-add-item" id="dropdownBasic1" ngbDropdownToggle (shown)="onDropdownShown()" (click)="onDropdownShown()">
          <img src="../assets/images/ic-add-white.svg" alt="Icon" />
        </button>
        <div ngbDropdownMenu #dropdownMenu aria-labelledby="dropdownBasic1" class="post-element-dropdown">
          <div #scrollBarContainer class="dropdown-scroll-wrapper">
            <button ngbDropdownItem [dndEffectAllowed]="'copy'" (dndDrag)="onStart($event)" (click)="addElement(element)"
                    [dndDraggable]="element" *ngFor="let element of articleElementList">
              <img src="../assets/images/ic-drag-{{element.name.replaceAll(' ','').toLowerCase()}}.svg" alt="Icon"
                   [ngClass]="{'resto-details-icon': element.id === 11}" />
              <span class="link-text">{{ element.name }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Delete Section Modal -->
<ng-template #deleteSectionModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close(false)"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-delete-section.svg" alt="Icon">
    </div>
    <h2 class="title-text" ngbAutofocus>Are you sure, want to delete this section?</h2>
    <h5 class="info-text">
      By deleting this section, you will also loose
      the content attached to this.
    </h5>
    <div class="btn-grps">
      <button class="btn btn-outline-danger" title="Delete" (click)="modal.close(true)">Delete</button>
    </div>
  </div>
</ng-template>


<!-- Image layout selection model -->
<app-article-image-layout-model #articleImageLayoutModel
                                (updateLayout)="updateLayout($event)"></app-article-image-layout-model>

<!--On Highlight text add description model -->
<app-article-highlight-model #articleHighlight
                             (hightlightTitleChange)="updateHighlightTextTitle($event)"></app-article-highlight-model>

<!--<app-translation-popup #translationModal></app-translation-popup>-->
<!-- Discard changes model -->
<ng-template #discardChangesModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-delete-section.svg" alt="Icon" />
    </div>
    <h2 class="title-text" ngbAutofocus>
      Are you sure, you want to discard the changes?
    </h2>
    <div class="btn-grps">
      <button class="btn btn-outline-primary" title="No" (click)="modal.close(false)">No</button>
      <button class="btn btn-primary" (click)="modal.close(true)" title="Yes">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #confirmTranslationModal let-modal>
  <div class="modal-head">
    <!--<button class="btn btn-close" (click)="modal.dismiss('Cross click')"></button>-->
  </div>
  <div class="modal-body text-center">
    <h2 class="confirm-title-text" ngbAutofocus>Create Translation</h2>
    <h5 class="confirm-info-text">Please make sure that your article is complete before going into the translation module</h5>
    <div class="btn-grps">
      <button class="btn btn-outline-primary" title="No" (click)="modal.close(false)">Cancel</button>
      <button class="btn btn-primary confirm-btn-radius ms-2" (click)="modal.close(true)" title="Yes">Proceed</button>
    </div>
  </div>
</ng-template>

<app-translation-popup #translation></app-translation-popup>
